import { render, staticRenderFns } from "./forwarderAll.vue?vue&type=template&id=60d513b6&scoped=true&"
import script from "./forwarderAll.vue?vue&type=script&lang=js&"
export * from "./forwarderAll.vue?vue&type=script&lang=js&"
import style0 from "./forwarderAll.vue?vue&type=style&index=0&id=60d513b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d513b6",
  null
  
)

export default component.exports